import * as KatalMetrics from '@amzn/katal-metrics';
import KatalMetricsDriverSushi from '@amzn/katal-metrics-driver-sushi';
import KatalMetricsDriverConsoleLogJson from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson';
import KatalMetricsDriverArrayCollector from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector';
import {
    KATAL_METRICS_PUBLISHER_PROCESS_NAME,
    OCULUS_SERVICE_METRIC_NAME,
    OPERATOR_ALIAS_METRIC_NAME, PUBLISH_KATAL_METRICS_FAILURE, SCC_WEBSITE_METRIC_NAME,
    STATION_CODE_METRIC_NAME
} from "./commons/constants/MetricConstants";
import {
    getOperatorAlias,
    getRegion,
    getStage,
    getStationCode,
    isDevelopmentEnv,
    logOperationalMetric
} from "./util/CommonUtils";
import {ENVIRONMENT, REALM} from "./commons/constants/CommonConstants";

const startTime = Date.now();

const metricsErrorHandler = (err) => {
    console.log("An error encountered while publishing KatalMetrics: {}", err)
    logOperationalMetric(startTime, KATAL_METRICS_PUBLISHER_PROCESS_NAME, PUBLISH_KATAL_METRICS_FAILURE, false);
}

const makeMetricsDriver = () => {
    const stage = getStage();
    const region = getRegion();
    const realm = REALM[region];
    if (process.env.NODE_ENV === ENVIRONMENT.TEST) {
        const metricsDriver = new KatalMetricsDriverArrayCollector();
        //  Attach to global window object so tests can see it
        window.metricsDriver = metricsDriver;
        return metricsDriver;
    } else if(isDevelopmentEnv()){
        return new KatalMetricsDriverConsoleLogJson();
    }
    else {
        return new KatalMetricsDriverSushi.Builder()
            .withDomainRealm(stage, realm)
            .withErrorHandler(metricsErrorHandler)
            .build();
    }
};

const makePublisher = async () => {
    const metricsDriver = makeMetricsDriver();
    const stationCode = getStationCode().stationCode;
    const operatorAlias = await getOperatorAlias();

    const initialMetricsContext = new KatalMetrics.Context.Builder()
        .withSite(SCC_WEBSITE_METRIC_NAME)
        .withServiceName(OCULUS_SERVICE_METRIC_NAME)
        .withRelatedMetrics(
            new KatalMetrics.Metric.String(STATION_CODE_METRIC_NAME, stationCode),
            new KatalMetrics.Metric.String(OPERATOR_ALIAS_METRIC_NAME, operatorAlias)
        )
        .build();

    return new KatalMetrics.Publisher(
        metricsDriver,
        metricsErrorHandler,
        initialMetricsContext);
};

const metricsPublisher = makePublisher();
export default metricsPublisher;



// WEBPACK FOOTER //
// ./src/metrics.js